// extracted by mini-css-extract-plugin
export default {"seminarWrapper":"lmim-tz0WDIa7tHDhkQRww==","privilegeContent":"i5zxWwoWPHJEfRh4qWDQ0w==","seminarWrapper2":"V2AKiAndIb8Ti6pugL5XXg=="};